module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"No Más IBEX 35","short_name":"No Más IBEX 35","description":"Alternativas a las empresas del IBEX 35","lang":"es","start_url":"/","background_color":"#242943","theme_color":"#242943","display":"minimal-ui","icon":"src/assets/images/website-icon.png","include_favicon":false,"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","cacheDigest":"8cd18a50b45b1611ce83e596199562f3"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
